module.exports = __webpack_public_path__ + "static/media/gst fill.a96fab92.png";